import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import EmptyPageBuilder from 'components/EmptyPage';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { commandWorkspaceProjectIngestList } from 'containers/ConnectionManager/actions.js';
import classEmptyDarkImage from 'images/class-empty-dark.png';
import classEmptyLightImage from 'images/class-empty-light.png';
import ImportList from 'components/Import/ImportList';
import { FileTypes } from 'constants/enums';

import messages from './messages';
import { getIngestionList } from '../../store/selectors';


const EmptyPage = EmptyPageBuilder.build({
  lightBackgroundImage: classEmptyLightImage,
  darkBackgroundImage: classEmptyDarkImage,
});

const ImportHistoryTab = ({ ingestionList, setImportModalVisible, getProjectIngestList, projectId }) => {
  const [showIngestionList, setShowIngestionList] = useState(false);

  const openImportModal = () => {
    setImportModalVisible(true);
  };

  const INGESTION_STATUS_FILTER_LIST = ['UPLOAD_FAILED', 'UPLOAD_CANCELLED'];

  const filteredIngestionList = ingestionList?.filter(
    (item) => !INGESTION_STATUS_FILTER_LIST.includes(item.status)
  );
  useEffect(() => {
    if (filteredIngestionList?.length) {
      setShowIngestionList(true);
    } else {
      /**
       *  We would need to provide else condition so if the user cancels ingestion
       *  in between we would show user empty page.
      */
      setShowIngestionList(false);
    }
  }, [filteredIngestionList]);

  useEffect(() => {
    getProjectIngestList(projectId);
  }, [getProjectIngestList, projectId]);

  return showIngestionList ? (
    <ImportList ingestionList={filteredIngestionList} ingestionType={FileTypes.EPUB} />
  ) : (
    <EmptyPage
      description={intl.formatMessage(messages.emptyImportPageDescription)}
      buttonText={intl.formatMessage(messages.emptyImportPageButton)}
      buttonCallback={openImportModal}
    />
  );
};

ImportHistoryTab.propTypes = {
  setImportModalVisible: PropTypes.func,
  ingestionList: PropTypes.array,
  getProjectIngestList: PropTypes.func.isRequired,
  projectId: PropTypes.string,
};

const mapStateToProps = (state) => ({
  ingestionList: getIngestionList(state),
});

function mapDispatchToProps(dispatch) {
  return {
    getProjectIngestList: (projectId) => dispatch(commandWorkspaceProjectIngestList(projectId)),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTheme
)(ImportHistoryTab);
